function onPasswordTogglePressed(event) {
  event.preventDefault();
  const el = event.currentTarget.button;
  const eye = el.children[0];
  const input = el.closest('.input-group').children[0];

  eye.classList.toggle('fe-eye-off');

  input.setAttribute('type', input.getAttribute('type') === 'password' ? 'text' : 'password');
}

export default function initPassword() {
  const passwordToggle = document.querySelectorAll('.password-toggle');

  passwordToggle.forEach((el) => {
    el.button = el;
    el.removeEventListener('click', onPasswordTogglePressed);
    el.addEventListener('click', onPasswordTogglePressed);
  });
}
